import React, { useEffect, useState } from 'react'
import { useAuth } from "../api/authStore"

const UserInfo = (props) => {

    const { user, getAccessTokenSilently, setToken, logout } = useAuth()

    const [newUserPassword, setUserPassword] = useState('')
    const [balanceC, setBalance] = useState(0)
    const [userEmail, setUserEmail] = useState('')
    const [error, setError] = useState(null)
    const [userData, setUserData] = useState([])
    const [userStats, setUserStats] = useState({})

    

    const handleChangePassword = (passwd) => {
        setUserPassword(passwd)
    }

    const handleChangeBalance = (balance) => {
        setBalance(balance)
    }

    const handleChangeEmail = (email) => {
        setUserEmail(email)
    }


    const handleClickGetUserInfo = async() => {
        try {
            const response = await props.apiClient.setToken(getAccessTokenSilently()).getUserInfo(userEmail)
            setUserData(response)
            setError(null)
        } catch (e) {
            if(e.response.data.error === 'accountNotFound'){
                setError('USER NOT FOUND')
            } else {
                setError('Error loading user data')
            }
        }
    }

    const handleClickChangePassword = async() => {
        try {
            const response = await props.apiClient.setToken(getAccessTokenSilently()).changeUserPasswordAdmin(userData?.userID, newUserPassword)

        } catch (e) {
            setError(JSON.stringify(e))
        }
    }

    const handleAddBalance = async() => {
        try {
            const response = await props.apiClient.setToken(getAccessTokenSilently()).addUserBalance(userData?.userID, balanceC)

        } catch (e) {
            setError(JSON.stringify(e))
        }
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--spacing-xl)',
            alignItems: 'center'
        }}>
            
            {/* Поиск пользователя */}
            <div style={{
                display: 'flex',
                gap: 'var(--spacing-md)',
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap'
            }}>
                <div style={{ position: 'relative' }}>
                    <input
                        type="text"
                        placeholder="Enter user email or ID"
                        value={userEmail}
                        onChange={(e) => handleChangeEmail(e.target.value)}
                        className="form-input"
                        style={{ minWidth: '625px' }}
                    />
                </div>
                <button
                    onClick={handleClickGetUserInfo}
                    className="btn btn-primary"
                    style={{ minWidth: '120px' }}
                >
                    Get Info
                </button>
            </div>

            {/* Ошибка */}
            {error && (
                <div className="form-error" style={{
                    textAlign: 'center',
                    maxWidth: '400px'
                }}>
                    {error}
                </div>
            )}

            {/* Информация о пользователе */}
            {userData && Object.keys(userData).length > 0 && (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: 'var(--spacing-lg)',
                    width: '100%',
                    maxWidth: '800px'
                }}>
                    
                    {/* Основная информация */}
                    <div className="form-card">
                        <h3 style={{
                            color: 'var(--text-light)',
                            fontSize: 'var(--text-lg)',
                            fontWeight: '600',
                            marginBottom: 'var(--spacing-lg)',
                            textAlign: 'center',
                            borderBottom: '1px solid var(--light-gray)',
                            paddingBottom: 'var(--spacing-md)'
                        }}>
                            👤 User Information
                        </h3>
                        
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 'var(--spacing-md)'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: 'var(--spacing-sm) 0',
                                borderBottom: '1px solid var(--dark-gray)'
                            }}>
                                <span style={{
                                    color: 'var(--text-muted)',
                                    fontSize: 'var(--text-sm)',
                                    fontWeight: '500'
                                }}>User ID:</span>
                                <span style={{
                                    color: 'var(--text-light)',
                                    fontSize: 'var(--text-sm)',
                                    fontFamily: 'var(--font-mono)',
                                    fontWeight: '600'
                                }}>{userData?.userID}</span>
                            </div>
                            
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: 'var(--spacing-sm) 0',
                                borderBottom: '1px solid var(--dark-gray)'
                            }}>
                                <span style={{
                                    color: 'var(--text-muted)',
                                    fontSize: 'var(--text-sm)',
                                    fontWeight: '500'
                                }}>Email:</span>
                                <span style={{
                                    color: 'var(--text-light)',
                                    fontSize: 'var(--text-sm)',
                                    fontWeight: '600'
                                }}>{userData?.email}</span>
                            </div>
                            
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: 'var(--spacing-sm) 0',
                                borderBottom: '1px solid var(--dark-gray)'
                            }}>
                                <span style={{
                                    color: 'var(--text-muted)',
                                    fontSize: 'var(--text-sm)',
                                    fontWeight: '500'
                                }}>Balance:</span>
                                <span style={{
                                    color: 'var(--primary-orange)',
                                    fontSize: 'var(--text-lg)',
                                    fontWeight: '700'
                                }}>${userData?.balanceCents ? (userData.balanceCents/100).toFixed(2) : '0.00'}</span>
                            </div>
                        </div>
                    </div>

                    {/* Статистика */}
                    <div className="form-card">
                        <h3 style={{
                            color: 'var(--text-light)',
                            fontSize: 'var(--text-lg)',
                            fontWeight: '600',
                            marginBottom: 'var(--spacing-lg)',
                            textAlign: 'center',
                            borderBottom: '1px solid var(--light-gray)',
                            paddingBottom: 'var(--spacing-md)'
                        }}>
                            📊 Statistics
                        </h3>
                        
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 'var(--spacing-md)'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: 'var(--spacing-sm) 0',
                                borderBottom: '1px solid var(--dark-gray)'
                            }}>
                                <span style={{
                                    color: 'var(--text-muted)',
                                    fontSize: 'var(--text-sm)',
                                    fontWeight: '500'
                                }}>Leased:</span>
                                <span style={{
                                    color: 'var(--text-light)',
                                    fontSize: 'var(--text-sm)',
                                    fontWeight: '600'
                                }}>{userData?.leased || 0}</span>
                            </div>
                            
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: 'var(--spacing-sm) 0',
                                borderBottom: '1px solid var(--dark-gray)'
                            }}>
                                <span style={{
                                    color: 'var(--text-muted)',
                                    fontSize: 'var(--text-sm)',
                                    fontWeight: '500'
                                }}>Refunded:</span>
                                <span style={{
                                    color: 'var(--text-light)',
                                    fontSize: 'var(--text-sm)',
                                    fontWeight: '600'
                                }}>{userData?.refunded || 0}</span>
                            </div>
                            
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: 'var(--spacing-sm) 0',
                                borderBottom: '1px solid var(--dark-gray)'
                            }}>
                                <span style={{
                                    color: 'var(--text-muted)',
                                    fontSize: 'var(--text-sm)',
                                    fontWeight: '500'
                                }}>Date Registered:</span>
                                <span style={{
                                    color: 'var(--text-light)',
                                    fontSize: 'var(--text-sm)',
                                    fontWeight: '600'
                                }}>N/A</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Административные действия */}
            {userData && Object.keys(userData).length > 0 && (
                <div className="form-card" style={{ maxWidth: '600px', width: '100%' }}>
                    <h3 style={{
                        color: 'var(--text-light)',
                        fontSize: 'var(--text-lg)',
                        fontWeight: '600',
                        marginBottom: 'var(--spacing-lg)',
                        textAlign: 'center',
                        borderBottom: '1px solid var(--light-gray)',
                        paddingBottom: 'var(--spacing-md)'
                    }}>
                        ⚙️ Admin Actions
                    </h3>
                    
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                        gap: 'var(--spacing-lg)'
                    }}>
                        
                        {/* Смена пароля */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 'var(--spacing-md)'
                        }}>
                            <label style={{
                                color: 'var(--text-light)',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '600'
                            }}>
                                Change Password
                            </label>
                            <input
                                type="password"
                                placeholder="Enter new password"
                                value={newUserPassword}
                                onChange={(e) => handleChangePassword(e.target.value)}
                                className="form-input"
                            />
                            <button
                                onClick={handleClickChangePassword}
                                className="btn btn-primary"
                                disabled={!newUserPassword.trim()}
                                style={{
                                    opacity: newUserPassword.trim() ? 1 : 0.5,
                                    cursor: newUserPassword.trim() ? 'pointer' : 'not-allowed'
                                }}
                            >
                                Change Password
                            </button>
                        </div>

                        {/* Добавление баланса */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 'var(--spacing-md)'
                        }}>
                            <label style={{
                                color: 'var(--text-light)',
                                fontSize: 'var(--text-sm)',
                                fontWeight: '600'
                            }}>
                                Add Balance
                            </label>
                            <input
                                type="number"
                                placeholder="Enter amount"
                                value={balanceC}
                                onChange={(e) => handleChangeBalance(e.target.value)}
                                className="form-input"
                            />
                            <button
                                onClick={handleAddBalance}
                                className="btn btn-outline"
                                disabled={!balanceC}
                                style={{
                                    opacity: balanceC ? 1 : 0.5,
                                    cursor: balanceC ? 'pointer' : 'not-allowed'
                                }}
                            >
                                Add Balance
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default UserInfo